export const mainNavigation = [
  {
    label: 'Home',
    path: '/',
    active: true
  },
  {
    label: 'Donate',
    path: '/donate',
    active: true
  },
  {
    label: 'Contact',
    path: '/contact',
    active: true
  }
];

export const ctaNavigation = {
  label: 'Book a Service',
  path: '/book',
  primary: true
};

export const footerNavigation = {
  services: [
    { label: 'Craniosacral Therapy', path: '/book', serviceId: 'craniosacral-therapy' },
    { label: 'Guided Meditation', path: '/book', serviceId: 'meditation' },
    { label: '1:1 Personal Session', path: '/book', serviceId: 'personal' }
  ],
  company: [
    { label: 'Events', path: '/events', disabled: true },
    { label: 'Donate', path: '/donate' },
    { label: 'Contact', path: '/contact' },
    { label: 'Coming Soon', path: '/coming-soon', disabled: true }
  ],
  support: [
    { label: 'FAQ', path: '#', disabled: true },
    { label: 'Privacy Policy', path: '#', disabled: true },
    { label: 'Terms of Service', path: '#', disabled: true },
    { label: 'Refund Policy', path: '#', disabled: true }
  ]
};

export const socialLinks = [
  {
    platform: 'Facebook',
    url: 'https://www.facebook.com/profile.php?id=100093640907094',
    icon: 'Facebook',
    color: '#1877F2'
  },
  {
    platform: 'Instagram',
    url: 'https://www.instagram.com/pragyavan.17/',
    icon: 'Instagram',
    color: '#E4405F'
  },
  {
    platform: 'Twitter',
    url: 'https://twitter.com/pragyavan',
    icon: 'Twitter',
    color: '#1DA1F2'
  },
  {
    platform: 'YouTube',
    url: 'https://youtube.com/@pragyavan',
    icon: 'Youtube',
    color: '#FF0000'
  }
];

export const quickActions = [
  {
    label: 'Call Now',
    action: 'tel:+918904568399',
    icon: 'Phone',
    type: 'link'
  },
  {
    label: 'WhatsApp',
    action: 'https://wa.me/918904568399',
    icon: 'MessageCircle',
    type: 'external',
    target: '_blank'
  },
  {
    label: 'Email Us',
    action: 'mailto:pragyavan2017@gmail.com',
    icon: 'Mail',
    type: 'link'
  }
];